import MessageQuestion from '@/app/_components/ui/icons/MessageQuestion.svg';
import React from 'react';

export default function Question({ question }) {
  return (
    <div className="py-4 relative border-t border-light-gray-300">
      <div
        className={`${question.answers && 'toc-border review-toc-border'}`}
      ></div>
      <div className="flex">
        <div className="">
          <MessageQuestion />
        </div>
        <div className="pr-3.5">
          <div>{question.question}</div>
          {question.answers && (
            <div className=" pt-7">{question.answers.answer} </div>
          )}
        </div>
      </div>
    </div>
  );
}
